module.exports = __webpack_public_path__ + "static/media/confusedparrot.67ec5d80.gif";